import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/organizations';
import { ResultState } from '@rootCommon/types/common';
import { Organization } from '@rootCommon/types/organization';

type Action = ActionType<typeof actions>;
export type OrganizationState = ResultState<Organization | null>;

const initState: OrganizationState = {
  data: null,
  loading: false,
  error: null,
};

export const organizationsItemReducer = (state = initState, action: Action): OrganizationState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchOrganization.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchOrganization.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchOrganization.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateOrganization.request):
      return { ...state, loading: true, error: null };
    case getType(actions.updateOrganization.success):
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case getType(actions.updateOrganization.failure):
      return { ...state, loading: false, error: action.payload };

      // default
    default:
      return state;
  }
};

export default organizationsItemReducer;
